import React from 'react';
import MapIcon from 'assets/svg/map-1-5.svg';
import ListIcon from 'assets/svg/list-1-5.svg';
import { CleanButton } from 'ds/components/button';
import { useLocale } from 'locale';
import { ListingMapSwitchButtonRoot, ListingMapSwitchButton, ButtonSeparator } from './styled';


interface MobileMapSwitcherProps {
  children?: JSX.Element;
  isMobileMapViewActive: boolean;
  hideMapSwitcher?: boolean;
  toggleMap: () => void;
}

export const MobileMapSwitcher: React.FC<MobileMapSwitcherProps> = (props): any => {
  const { isMobileMapViewActive, toggleMap, children, hideMapSwitcher } = props;
  const { t } = useLocale();
  const hasButton = !!React.Children.count(children);

  return (
    <ListingMapSwitchButtonRoot>
      <ListingMapSwitchButton>
        {hasButton ? children : null}
        {hideMapSwitcher || !hasButton ? null : <ButtonSeparator />}
        {hideMapSwitcher ? null : (
          <CleanButton
            data-auto="map-list-view-button"
            data-auto-state={isMobileMapViewActive ? 'map' : 'list'}
            onClick={toggleMap}
          >
            {isMobileMapViewActive ? <ListIcon /> : <MapIcon />}
            {t('searchListView.mobileMapViewToggle', { isMobileMapViewActive })}
          </CleanButton>
        )}
      </ListingMapSwitchButton>
    </ListingMapSwitchButtonRoot>
  );
};
